import { ImageProps } from "./types";

export type RenderImageProps = ImageProps & {
  className?: string;
  sizes?: string;
  loading?: "eager" | "lazy";
  priority?: boolean;
};

export type RenderImage = (props: RenderImageProps) => JSX.Element;

export const defaultRenderImage: RenderImage = ({
  src,
  alt,
  width,
  height,
  className,
  sizes,
  loading,
  priority,
}) => (
  <img
    src={src}
    alt={alt}
    width={width}
    height={height}
    className={className}
    sizes={sizes}
    loading={priority ? "eager" : loading}
  />
);
